<!-- Spinner -->

<!-- Gird Entry -->
<ng-template #block_entry_template let-slide="slide" let-page="page" let-routeElement="routeElement">
  @if (slide && page && routeElement) {
    <figure [routerLink]="['/' + routeElement.path]"
      class="mdsf-thumbnail">
      @if (slide.hidden === false) {
        <div class="resource-type-icon" [title]="mediaControlService.getMediaTypeLabel({ type: page.mediaType }) | translate">
          <span [class]="'fa ' + mediaControlService.getMediaTypeIcon({ type: page.mediaType })"></span>
        </div>
        @if ({media: (appSharedFacade.media$(page.thumbnailMedia) | async) }; as data) {
          @if (data?.media?.thumbnail) {
            <img
              [src]="mediaControlService.getUrl(data.media, 'thumbnail')"
              [alt]="data.media.altText"/>
          } 
          @else {
            <div class="img-placeholder d-flex justify-content-center align-items-center">
              <span [class]="'fa text-secondary fa-3x ' + mediaControlService.getMediaTypeIcon({ type: page.mediaType })"></span>
            </div>
          }
        }
        <figcaption>
          <div class="text" [title]="page.title">
            <span class="truncate truncate-multiline">
              <!--
              <span *ngIf="slide?.page?.compoundNumber">{{ slide.page.compoundNumber }}:</span>
              -->
              {{ page.title }}
            </span>
          </div>
          <a class="nav" [routerLink]="['/' + routeElement.path]">
            <i class="fa fa-chevron-right" aria-label=""></i>
          </a>
        </figcaption>
        <!--
        <figcaption class="temporary" *ngIf="!slides.loaded">
          <div class="box box-upper"></div>
          <div class="box box-lower"></div>
        </figcaption>
        -->
      }
    </figure>
  }
</ng-template>

<!-- Content -->
@if ((nodeSharedFacade.currentSelectedBlockPage$ | async); as blockPage) {
  <div
    class="m-3">
    <medsurf-text-format [text]="blockPage.body"></medsurf-text-format>
  </div>
}
@if ((nodeSharedFacade.currentSelectedSlideNodesFiltered$ | async) | sortBy_shared:'asc':'position'; as slides) {
  <div class="mdsf-grid p-2 thumbnail-container scrollable">
    @for (slide of slides; track slide) {
      @if (slides !== undefined) {
      } @else {
        <div class="d-flex justify-content-center m-2">
          <div class="spinner-border"></div>
        </div>
      }
    <ng-container *ngTemplateOutlet="block_entry_template;context:{
                  slide: slide,
                  page: (appSharedFacade.page$(slide.page) | async),
                  routeElement: (appSharedFacade.routeElement$(slide.id) | async)}">
      </ng-container>
    }
  </div>
}
